import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#1f1b2e] text-white">
      <div className="max-w-3xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate("/auth")}
            className="inline-flex items-center gap-2 bg-[#ffffff1a] hover:bg-white/20 text-white px-4 py-2 rounded-xl text-sm transition"
          >
            ← Back to Login
          </button>
          <Link
            to="/"
            className="text-sm text-white/70 hover:text-white underline-offset-4 hover:underline"
          >
            Back to website
          </Link>
        </div>

        <h1 className="text-3xl font-semibold mb-6">Terms & Conditions</h1>
        <div className="space-y-8 text-white/90 leading-7">
          <section>
            <h2 className="text-xl font-semibold mb-2">Introduction</h2>
            <p>
              Welcome to JobStep. By accessing or using our application, you
              agree to be bound by these Terms & Conditions. If you do not agree
              with any part of these terms, you should discontinue use of the
              application.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">User Responsibilities</h2>
            <p>
              You are responsible for maintaining the confidentiality of your
              account and for all activities that occur under your account. You
              agree not to misuse the application, attempt to access data without
              authorization, or engage in activities that may disrupt the
              service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Privacy Policy</h2>
            <p>
              We value your privacy. Our data collection and usage practices are
              described in our Privacy Policy. By using the application, you
              consent to the collection and use of information as outlined there.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">Contact Information</h2>
            <p>
              If you have questions about these Terms & Conditions, please reach
              out to us at info@rakfort.com
            </p>
          </section>

          <p className="text-xs text-white/60">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
